import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "font-semibold text-black-lp-300 flex flex-row items-center",
  style: {"gap":"8px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, null, -1)
const _hoisted_4 = { class: "relative flex items-center justify-between" }
const _hoisted_5 = {
  class: "flex items-center",
  style: {"gap":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DetailSender = _resolveComponent("DetailSender")!
  const _component_BookingSdnBanner = _resolveComponent("BookingSdnBanner")!
  const _component_DetailReceiver = _resolveComponent("DetailReceiver")!
  const _component_CommoditySection = _resolveComponent("CommoditySection")!
  const _component_DocInternational = _resolveComponent("DocInternational")!
  const _component_DeliveryType = _resolveComponent("DeliveryType")!
  const _component_weight_cost = _resolveComponent("weight-cost")!
  const _component_check_tariff_v2 = _resolveComponent("check-tariff-v2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    ref: "modal-booking-reverse",
    title: _ctx.$t('Ubah Data Alamat'),
    onClose: _ctx.closeModal,
    contentBgColor: "bg-gray-lp-1000",
    marginFooter: "mt-0",
    marginHeader: "mb-0",
    footerBgColor: "bg-white",
    footerPadding: "p-4"
  }, {
    content: _withCtx(() => [
      _createVNode("div", null, [
        (_ctx.isRtsOrCnx)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              rounded: "xl",
              class: "flex flex-col p-3 mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataWrapper, null, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_1, [
                      _createVNode(_component_Icons, {
                        name: "drop-package",
                        style: {"width":"24px","height":"24px"}
                      }),
                      _createVNode("p", null, _toDisplayString(_ctx.$t("Pos pembooking")), 1)
                    ]),
                    _createVNode(_component_SelectSearch, {
                      onFocus: _cache[1] || (_cache[1] = (search) => _ctx.filterPartners(search, true)),
                      onFilter: _cache[2] || (_cache[2] = (search) => _ctx.filterPartners(search, true)),
                      isLoading: _ctx.isLoadingPartners,
                      options: _ctx.partnersData,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('Pilih POS'),
                      modelValue: _ctx.selectedPartnerPos,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedPartnerPos = $event)),
                      onChange: _ctx.onChangePartner,
                      class: "mt-2",
                      isDisabled: 
                !_ctx.isRtsOrCnx
                  ? _ctx.isUserHasPartnerPos
                    ? true
                    : _ctx.disableSelectPartnerField
                  : _ctx.isRTS
                  ? true
                  : _ctx.disableSelectPartnerField
              
                    }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onChange", "isDisabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DetailSender, {
          ref: "detail-sender",
          id: "booking-sender-section",
          class: "mb-2",
          modelValue: _ctx.formBooking,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formBooking = $event)),
          currentIndex: _ctx.currentIndex,
          "onUpdate:currentIndex": _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentIndex = $event)),
          errors: _ctx.error,
          "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => (_ctx.error = $event)),
          senderNameIndex: 1,
          senderPhoneIndex: 2,
          senderAddressIndex: 3,
          saveSenderIndex: 4,
          isShowSaveSender: false,
          configName: _ctx.configDisabled,
          configPhone: _ctx.configDisabled,
          configSaveAddress: _ctx.configDisabled,
          configAddress: _ctx.configDisabled,
          isReverseJourneyDetail: true,
          phoneNumberFieldId: "booking-rj-sender-phone-input"
        }, null, 8, ["modelValue", "currentIndex", "errors", "configName", "configPhone", "configSaveAddress", "configAddress"]),
        _createVNode(_component_DetailReceiver, {
          ref: "detail-receiver",
          id: "booking-receiver-section",
          class: "mb-2",
          modelValue: _ctx.formBooking,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formBooking = $event)),
          postalCodeDestination: _ctx.formBooking.postalCodeDestination,
          "onUpdate:postalCodeDestination": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formBooking.postalCodeDestination = $event)),
          currentIndex: _ctx.currentIndex,
          "onUpdate:currentIndex": _cache[9] || (_cache[9] = ($event: any) => (_ctx.currentIndex = $event)),
          errors: _ctx.error,
          "onUpdate:errors": _cache[10] || (_cache[10] = ($event: any) => (_ctx.error = $event)),
          listKGs: _ctx.formBooking.pieces,
          recipientNameIndex: 5,
          recipientPhoneIndex: 6,
          recipientAddressIndex: 7,
          recipientDistrictIndex: 8,
          recipientPostalCodeIndex: 9,
          saveReceiverIndex: 10,
          isReverseJourneyDetail: true,
          isErrorRouteNotFound: _ctx.errorRouteNotFound,
          configName: _ctx.disabledDetailReceiver,
          configPhone: _ctx.disabledDetailReceiver,
          configAddress: _ctx.disabledDetailReceiver,
          configDistrict: _ctx.disabledDetailReceiver,
          configPostalCode: _ctx.disabledDetailReceiver,
          configSaveAddress: _ctx.disabledDetailReceiver,
          phoneNumberFieldId: "booking-rj-receiver-phone-input"
        }, {
          "destination-info": _withCtx(() => [
            _createVNode(_component_BookingSdnBanner, {
              variant: "v3",
              originDistrict: _ctx.districtDetail,
              destinationDistrict: _ctx.formBooking.destinationCity,
              active: _ctx.sdnReady
            }, null, 8, ["originDistrict", "destinationDistrict", "active"])
          ]),
          _: 1
        }, 8, ["modelValue", "postalCodeDestination", "currentIndex", "errors", "listKGs", "isErrorRouteNotFound", "configName", "configPhone", "configAddress", "configDistrict", "configPostalCode", "configSaveAddress"]),
        _createVNode(_component_CommoditySection, {
          ref: "commodity",
          id: "booking-commodity-section",
          modelValue: _ctx.formBooking,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formBooking = $event)),
          currentIndex: _ctx.currentIndex,
          "onUpdate:currentIndex": _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentIndex = $event)),
          error: _ctx.error,
          "onUpdate:error": _cache[13] || (_cache[13] = ($event: any) => (_ctx.error = $event)),
          commodityIndex: 11
        }, null, 8, ["modelValue", "currentIndex", "error"]),
        _hoisted_2,
        (_ctx.isFtzAccount)
          ? (_openBlock(), _createBlock(_component_DocInternational, {
              ref: "ftz",
              id: "booking-ftz-section",
              modelValue: _ctx.formBooking.ftzForm,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formBooking.ftzForm = $event)),
              currentIndex: _ctx.currentIndex,
              "onUpdate:currentIndex": _cache[15] || (_cache[15] = ($event: any) => (_ctx.currentIndex = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[16] || (_cache[16] = ($event: any) => (_ctx.error = $event)),
              key: _ctx.formBooking.ftzForm.listCommodityCIPL.length,
              isFtz: true,
              indexListCommodityCIPL: 12,
              indexEmail: 13,
              indexIdNumber: 14,
              indexTaxNumber: 15,
              indexShipmentStatus: 16,
              indexImageIdUrl: 17,
              indexImageTaxUrl: 18,
              indexImageBeforePackingUrl: 19,
              indexImageAfterPackingUrl: 20
            }, null, 8, ["modelValue", "currentIndex", "error"]))
          : _createCommentVNode("", true),
        _hoisted_3,
        _createVNode(_component_DeliveryType, {
          id: "booking-product-section",
          class: "flex-grow",
          currentIndex: _ctx.currentIndex,
          "onUpdate:currentIndex": _cache[17] || (_cache[17] = ($event: any) => (_ctx.currentIndex = $event)),
          modelValue: _ctx.formBooking.productName,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formBooking.productName = $event)),
          isErrorUpselling: _ctx.isErrorUpselling,
          productIndex: 21,
          listProduct: _ctx.listProducts,
          isLoadingUpselling: _ctx.loadingUpsellingData,
          upsellingData: _ctx.upsellingData,
          isBookingRetail: false,
          onRetry: _ctx.getUpsellingData,
          formType: _ctx.isCustomerApps ? 'retail' : _ctx.formType
        }, null, 8, ["currentIndex", "modelValue", "isErrorUpselling", "listProduct", "isLoadingUpselling", "upsellingData", "onRetry", "formType"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_weight_cost, {
            formType: _ctx.isCustomerApps ? 'retail' : _ctx.formType,
            totalItem: _ctx.formBooking.pieces.length,
            totalGrossWeight: _ctx.totalGrossWeight,
            totalDimensionWeight: _ctx.estimationVolumeWeight,
            totalVolumeWeight: _ctx.totalVolumeWeight,
            chargeableWeight: _ctx.formattedChargeableWeight,
            clientCountry: _ctx.form?.sttBookedByCountry,
            isCampaign: false,
            id: "weight-cost-footer"
          }, null, 8, ["formType", "totalItem", "totalGrossWeight", "totalDimensionWeight", "totalVolumeWeight", "chargeableWeight", "clientCountry"]),
          _createVNode(_component_check_tariff_v2, {
            form: "manual",
            estimationPrice: _ctx.estimationPriceData,
            isDisabled: false,
            payload: {},
            formType: _ctx.isCustomerApps ? 'manual' : _ctx.formType,
            isCustomerApps: _ctx.isCustomerApps,
            isCodRetail: 
              _ctx.formBooking.serviceType === 'cod' ||
                _ctx.formBooking.serviceType === 'dfod'
            ,
            goodsValue: _ctx.formBooking.estimationPrice,
            isLoading: _ctx.loadingEstimationPrice,
            isError: _ctx.errorEstimationPrice,
            idTariff: "id-tariff-booking-v3",
            onRefresh: _ctx.refreshCheckTariff
          }, null, 8, ["estimationPrice", "formType", "isCustomerApps", "isCodRetail", "goodsValue", "isLoading", "isError", "onRefresh"])
        ]),
        _createVNode(_component_LpButton, {
          "data-testid": "booking-rj-button-save",
          class: "focus-within:border focus-within:border-blue focus-within:ring-2 focus-within:ring-blue",
          customClass: "focus:ring-2 focus:ring-blue",
          title: _ctx.$t('Simpan Perubahan'),
          textColor: "white",
          onClick: _ctx.onSubmitEdit,
          disabled: !_ctx.isFormValid
        }, null, 8, ["title", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
}